import { QueryClient } from '@tanstack/react-query';
import { readSignupAttribution } from '../../Domain/utils/signupAttribution';
import { httpClient } from './httpClient.config';

export const entryQueryClientConfig = new QueryClient();

entryQueryClientConfig.setMutationDefaults(['send_verification'], {
  mutationFn: async (data) =>
    await httpClient.post('/v1/api/accounts/resend_mail', data).then((res) => res.data),
});

entryQueryClientConfig.setMutationDefaults(['accounts/login'], {
  mutationFn: async (data) =>
    await httpClient
      .post('/v1/api/accounts/log_in', { ...data, email: data.username })
      .then((response) => response.data),
});

entryQueryClientConfig.setMutationDefaults(['accounts'], {
  mutationFn: async (data) => {
    // Extract 'onboarding_id' from the current URL
    const queryParams = new URLSearchParams(window.location.search);
    const onboardingId = queryParams.get('onboarding_id');
    const attribution = readSignupAttribution();

    const payload = {
      ...data,
      email: data.username,
      ...(onboardingId ? { onboarding_id: onboardingId } : {}),
      ...(attribution ? { attribution } : {}),
    };

    return await httpClient
      .post('v1/api/accounts/create', payload)
      .then((response) => response.data);
  },
});

entryQueryClientConfig.setMutationDefaults(['accounts/forgot-password'], {
  mutationFn: async (data) =>
    await httpClient
      .post('/v1/api/accounts/forgot_password', data)
      .then((response) => response.data),
});

entryQueryClientConfig.setMutationDefaults(['accounts/reset-password'], {
  mutationFn: async ({ uidb64, token, ...data }) =>
    await httpClient
      .post(`/v1/api/accounts/reset-password/${uidb64}/${token}`, data)
      .then((response) => response.data),
});
